import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import {
  Modal, Form, Icon, Button, Table, Select,
} from 'semantic-ui-react';

import MessageList from '../../reusable/MessageList';
import Fetcher from '../../reusable/Fetcher';
import alarmConfigSchema from '../../../schemas/alarmConfig';

class NewAlarmConfigModal extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    getOrganisationUsers: PropTypes.func.isRequired,
    getOrganisationMachines: PropTypes.func.isRequired,
    closeNewAlarmConfigModal: PropTypes.func.isRequired,
    closeEditAlarmsConfigModal: PropTypes.func.isRequired,
    updateItemAction: PropTypes.func,
    submitAlarmConfig: PropTypes.func.isRequired,
    values: PropTypes.shape({}),
    users: PropTypes.shape({
      isPending: PropTypes.bool.isRequired,
      allIds: PropTypes.arrayOf(PropTypes.string).isRequired,
      byId: PropTypes.shape({}).isRequired,
    }).isRequired,
    machines: PropTypes.shape({
      isPending: PropTypes.bool.isRequired,
      allIds: PropTypes.arrayOf(PropTypes.string).isRequired,
      byId: PropTypes.shape({}).isRequired,
    }).isRequired,
    alarmsConfig: PropTypes.shape({
      isPending: PropTypes.bool.isRequired,
      allIds: PropTypes.arrayOf(PropTypes.string).isRequired,
      byId: PropTypes.shape({}).isRequired,
    }).isRequired,
  };

  static defaultProps = {
    values: null,
    updateItemAction: null,
  };

  constructor(props) {
    super(props);
    const { values } = props;
    if (values) {
      this.state = {
        configId: values.id,
        yellowConfig: values.yellowConfig.map(config => ({ ...config })),
        redConfig: values.redConfig.map(config => ({ ...config })),
        machinesId: [values.machineId],
      };
    } else {
      this.state = {
        yellowConfig: [{
          email: [],
          sms: [],
          value: '',
        }, {
          email: [],
          sms: [],
          value: '',
        }, {
          email: [],
          sms: [],
          value: '',
        }],
        redConfig: [{
          email: [],
          sms: [],
          value: '',
        }, {
          email: [],
          sms: [],
          value: '',
        }, {
          email: [],
          sms: [],
          value: '',
        }],
        machinesId: [],
        messages: [],
        isError: false,
      };
    }
    this.updateField = this.updateField.bind(this);
    this.submitAlarmConfig = this.submitAlarmConfig.bind(this);
    this.selectMachine = this.selectMachine.bind(this);
  }

  updateField(index, value, type, level) {
    this.setState((prevState) => {
      const typeState = prevState[type];
      typeState[level][index] = value;
      return { ...prevState, [type]: typeState };
    });
  }

  submitAlarmConfig() {
    const { machinesId, yellowConfig, redConfig } = this.state;
    const errors = [];

    // Validate ids only if it is a new alarm config.
    if (!this.props.values) {
      const validMachinesId = alarmConfigSchema.machinesId.validate.validator(machinesId);
      if (!validMachinesId) {
        errors.push(alarmConfigSchema.machinesId.validate.message);
      }
    }

    for (let i = 0; i < 3; i++) {
      if (!alarmConfigSchema.yellowConfig.value.validate.validator(yellowConfig[i].value)) {
        errors.push(alarmConfigSchema.yellowConfig.value.validate.message);
        break;
      }
    }

    for (let i = 0; i < 3; i++) {
      if (!alarmConfigSchema.redConfig.value.validate.validator(redConfig[i].value)) {
        errors.push(alarmConfigSchema.redConfig.value.validate.message);
        break;
      }
    }

    if (errors.length) {
      this.setState({ messages: errors, isError: true });
    } else {
      const { values, updateItemAction, submitAlarmConfig } = this.props;
      const { messages, isError, ...rest } = this.state;
      if (values) {
        updateItemAction({ ...rest });
      } else {
        submitAlarmConfig({ ...rest });
      }
    }
  }

  selectMachine(e, { value }) {
    this.setState({ machinesId: value });
  }

  render() {
    const {
      t, getOrganisationUsers, getOrganisationMachines, closeEditAlarmsConfigModal,
      users, values, machines, alarmsConfig, closeNewAlarmConfigModal,
    } = this.props;
    const { yellowConfig, redConfig } = this.state;
    const { isPending: isPendingUsers, allIds, byId } = users;
    const { isPending: isPendingMachines } = machines;
    const emailOptions = allIds.map(id => ({
      key: id,
      value: byId[id].email,
      text: `${byId[id].firstName} ${byId[id].lastName}`,
    }));
    const smsOptions = allIds.map(id => ({
      key: id,
      value: byId[id].mobileNumber,
      text: `${byId[id].firstName} ${byId[id].lastName}`,
    }));

    // For excluding already configured machines from dropdown.
    const alarmConfigMachineIds = values ? [] : alarmsConfig.allIds.map(id => alarmsConfig.byId[id].machineId);

    return (
      <Modal open size="large">
        <Modal.Header className="modal-header">
          {values
            ? <span>{values.machineShortName}</span>
            : <span>{t('alarmsConfig.create')}</span>
          }
        </Modal.Header>
        <Modal.Content>
          <Fetcher
            fetchAction={values ? getOrganisationUsers : [getOrganisationUsers, getOrganisationMachines]}
            isLoading={values ? isPendingUsers : (isPendingUsers && isPendingMachines)}
          >
            <MessageList isError={this.state.isError} messages={this.state.messages} />
            {!values
              && (
                <div>
                  <span><b>{t('alarmsConfig.select-machine')}</b></span>
                  {' '}
                  <Select
                    multiple
                    options={machines.allIds.filter(id => !alarmConfigMachineIds.includes(id)).map(machineId => ({
                      key: machines.byId[machineId].id,
                      value: machines.byId[machineId].id,
                      text: machines.byId[machineId].shortName,
                    }))}
                    onChange={this.selectMachine}
                  />
                </div>
              )
             }
            <Table>
              <Table.Header>
                <Table.Row>
                  <Table.Cell width={2}>{t('common.level')}</Table.Cell>
                  <Table.Cell width={2}>{t('common.time')} (m)</Table.Cell>
                  <Table.Cell>{t('common.email')}</Table.Cell>
                  <Table.Cell>SMS</Table.Cell>
                </Table.Row>
              </Table.Header>

              <Table.Body>
                {yellowConfig.map((info, index) => (
                  <Table.Row key={index}>
                    <Table.Cell>
                      {Array.from(new Array(index + 1)).map((v, i) => <Icon key={i} name="attention" color="yellow" />)}
                    </Table.Cell>
                    <Table.Cell>
                      <Form.Input
                        fluid
                        value={info.value}
                        onChange={(e, { value }) => this.updateField('value', value, 'yellowConfig', index)}
                      />
                    </Table.Cell>
                    <Table.Cell>
                      <Form.Select
                        multiple
                        value={info.email}
                        options={emailOptions}
                        onChange={(e, { value }) => this.updateField('email', value, 'yellowConfig', index)}
                      />
                    </Table.Cell>
                    <Table.Cell>
                      <Form.Select
                        multiple
                        value={info.sms}
                        options={smsOptions}
                        onChange={(e, { value }) => this.updateField('sms', value, 'yellowConfig', index)}
                      />
                    </Table.Cell>
                  </Table.Row>
                ))}
                {redConfig.map((info, index) => (
                  <Table.Row key={index}>
                    <Table.Cell>
                      {Array.from(new Array(index + 1)).map((v, i) => <Icon key={i} name="attention" color="red" />)}
                    </Table.Cell>
                    <Table.Cell>
                      <Form.Input
                        fluid
                        value={info.value}
                        onChange={(e, { value }) => this.updateField('value', value, 'redConfig', index)}
                      />
                    </Table.Cell>
                    <Table.Cell>
                      <Form.Select
                        multiple
                        value={info.email}
                        options={emailOptions}
                        onChange={(e, { value }) => this.updateField('email', value, 'redConfig', index)}
                      />
                    </Table.Cell>
                    <Table.Cell>
                      <Form.Select
                        multiple
                        value={info.sms}
                        options={smsOptions}
                        onChange={(e, { value }) => this.updateField('sms', value, 'redConfig', index)}
                      />
                    </Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>
            <Button
              onClick={() => (values ? closeEditAlarmsConfigModal(values.id) : closeNewAlarmConfigModal())}
            >
              {t('common.cancel')}
            </Button>
            <Button
              icon
              positive
              loading={values ? alarmsConfig.isPendingUpdate : alarmsConfig.isPendingAdd}
              labelPosition="left"
              floated="right"
              onClick={this.submitAlarmConfig}
            >
              <Icon name={values ? 'check' : 'add'} />
              {values
                ? <span>{t('common.update')}</span>
                : <span>{t('common.create')}</span>
              }
            </Button>
          </Fetcher>
        </Modal.Content>
      </Modal>
    );
  }
}

export default translate()(NewAlarmConfigModal);



// WEBPACK FOOTER //
// ./src/components/Settings/alarms/NewAlarmConfigModal.js